if (!customElements.get('image-comparison')) {
  customElements.define(
    'image-comparison',
    class ImageComparison extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector('button');
        this.isHorizontal = this.dataset.direction === 'horizontal';

        this.startDrag = this.onStartDrag.bind(this);
        this.drag = this.onDrag.bind(this);
        this.stopDrag = this.onStopDrag.bind(this);

        if (FoxTheme.config.motionReduced) {
          this.init();
        } else {
          FoxTheme.Motion.inView(this.querySelector('.image-comparison__animation-trigger'), this.animation.bind(this));
        }
      }

      init() {
        this.buttonIcon = this.button.querySelector('span');
        this.offset = this.buttonIcon ? this.buttonIcon.offsetWidth / 2 : 20;

        this.button.addEventListener('touchstart', this.startDrag);
        this.button.addEventListener('mousedown', this.startDrag);
      }

      animation() {
        this.setAttribute('is-visible', '');
        this.classList.add('is-animating');
        setTimeout(() => {
          this.classList.remove('is-animating');
        }, 1e3);
        this.init();
      }

      onStartDrag(e) {
        e.preventDefault();
        document.body.classList.add('body-no-scrollbar');
        this.classList.add('is-dragging');
      
        const event = (e.touches && e.touches[0]) || e;
      
        // Get the bounding rect of the button relative to the viewport
        const buttonRect = this.button.getBoundingClientRect();
      
        // Calculate the initial offset between the cursor and the button's position
        if (this.isHorizontal) {
          this.initialOffset = event.pageX - buttonRect.left;
        } else {
          this.initialOffset = event.pageY - buttonRect.top;
        }
      
        if (e.type === 'mousedown') {
          document.addEventListener('mousemove', this.drag);
          document.addEventListener('mouseup', this.stopDrag);
        } else if (e.type === 'touchstart') {
          document.addEventListener('touchmove', this.drag);
          document.addEventListener('touchend', this.stopDrag);
        }
      }
      
      onStopDrag() {
        document.body.classList.remove('body-no-scrollbar');
        this.classList.remove('is-dragging');

        document.removeEventListener('mousemove', this.drag);
        document.removeEventListener('mouseup', this.stopDrag);

        document.removeEventListener('touchmove', this.drag);
        document.removeEventListener('touchend', this.stopDrag);
      }
  
      onDrag(e) {
        const event = (e.touches && e.touches[0]) || e;
      
        // Get the bounding rect of the comparison container
        const containerRect = this.getBoundingClientRect();
      
        let position, distance;
      
        // Calculate the cursor's position relative to the container
        if (this.isHorizontal) {
          position = event.pageX - containerRect.left - this.initialOffset;
          distance = containerRect.width;
        } else {
          position = event.pageY - containerRect.top - this.initialOffset;
          distance = containerRect.height;
        }
      
        const max = distance - this.offset;
        const min = this.offset;
        const clampedPosition = Math.max(min, Math.min(position, max));
        const percent = (clampedPosition * 100) / distance;
      
        // Update the style property for the draggable line
        this.style.setProperty('--percent', percent + '%');
      }
    }
  );
}
